import {
  MILLISECONDS_IN_SECOND,
  SECONDS_IN_HOUR,
} from '@seekingalpha/samw-utils';

import { getTickerLogoUrl } from 'Shared/tickers/utils';
import { isWrapper } from 'Wrapper/criticals';
import { MARKETPLACE_AUDIO_POST } from 'Constants/articleTypes';

import type { FullArticleT } from 'Shared/types/ApiModels';
import type { ServicePlanArticleT } from 'Services/api/types';

const ISO_HOURS_INDEX = 11;
const ISO_MINUTES_INDEX = 14;
const ISO_TIME_END_INDEX = 19;
const THUMBNAIL_MAPPER = {
  news: (article: FullArticleT, isDarkMode: boolean) => {
    const slug = article.primaryTickers?.[0]?.slug;
    return slug ? getTickerLogoUrl(slug, !isWrapper && isDarkMode) : '';
  },
  article: (article: FullArticleT) => {
    return article.author?.image?.extraLarge ?? '';
  },
  [MARKETPLACE_AUDIO_POST]: (article: ServicePlanArticleT) => {
    return article.author?.image?.extraLarge ?? '';
  },
};

export const convertSecondsToHMS = (seconds: number = 0) => {
  const sliceIndex =
    seconds >= SECONDS_IN_HOUR ? ISO_HOURS_INDEX : ISO_MINUTES_INDEX;

  return new Date(seconds * MILLISECONDS_IN_SECOND)
    .toISOString()
    .slice(sliceIndex, ISO_TIME_END_INDEX);
};

export const getAudioTrackThumbnail = (
  articleType: string,
  isDarkMode: boolean,
  article: FullArticleT | ServicePlanArticleT,
) => {
  // @ts-expect-error ImplicitAny
  return THUMBNAIL_MAPPER[articleType]?.(article, isDarkMode) ?? '';
};
